import { useEffect, useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Trash2, FlaskConical } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const FIELDS = [
  ["offer_timeout_seconds", "Tempo para o prestador aceitar (segundos)", "number"],
  ["radius_km", "Raio máximo de busca (km)", "number"],
  ["free_limit", "Pedidos grátis por prestador", "number"],
  ["availability_hours", "Desligar 'Disponível' depois de (horas)", "number"],
  ["pro_price_text", "Preço do plano Pro (texto exibido)", "text"],
];

export default function AdminSettings() {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["admin-settings"], queryFn: () => api.get("/admin/settings").then((r) => r.data) });
  const [f, setF] = useState(null);
  useEffect(() => { if (data) setF(data); }, [data]);
  if (!f) return null;
  const save = async (e) => {
    e.preventDefault();
    try {
      const body = Object.fromEntries(FIELDS.map(([k, , t]) => [k, t === "number" ? Number(f[k]) : f[k]]));
      await api.put("/admin/settings", body);
      toast.success("Configurações salvas");
      qc.invalidateQueries();
    } catch (err) { toast.error(errMsg(err)); }
  };
  const testData = async (method) => {
    if (method === "delete" && !window.confirm("Remover todos os usuários, prestadores e pedidos de teste?")) return;
    try { const { data: r } = await api[method]("/admin/test-data"); toast.success(method === "delete" ? `Removidos: ${r.deleted_users} usuários de teste` : `Criados: ${r.created}`); qc.invalidateQueries(); }
    catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <div className="grid gap-5 lg:grid-cols-2">
      <form onSubmit={save} className="po-card space-y-4" data-testid="admin-settings-form">
        {FIELDS.map(([k, label, type]) => (
          <div key={k}>
            <label className="po-label" htmlFor={`set-${k}`}>{label}</label>
            <input id={`set-${k}`} type={type} step="any" className="po-input" value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`admin-setting-${k}`} />
          </div>
        ))}
        <button className="po-btn-primary w-full" data-testid="admin-settings-save">Salvar configurações</button>
      </form>
      <div className="po-card space-y-3" data-testid="admin-test-data">
        <p className="flex items-center gap-2 text-xl font-bold"><FlaskConical className="h-6 w-6 text-orange-500" /> Dados de teste</p>
        <p className="text-base text-slate-700">Contas marcadas como “teste” não aparecem para o público. Pedidos de teste só vão para prestadores de teste.</p>
        <button onClick={() => testData("post")} className="po-btn-outline w-full" data-testid="admin-test-data-create">Criar dados de teste</button>
        <button onClick={() => testData("delete")} className="po-btn w-full bg-red-600 text-white hover:bg-red-700" data-testid="admin-test-data-delete"><Trash2 className="h-5 w-5" /> Remover dados de teste</button>
      </div>
    </div>
  );
}
